import axiosInstance from "./config";

const basePath = `/induk-app/qris-manual`;

export const getManualQRIS = () => {
  return axiosInstance.get(`${basePath}`);
};

export const updateManualQRIS = (image: File) => {
  const formData = new FormData();
  formData.append("image", image);
  return axiosInstance.patch(`${basePath}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
